import React from 'react'
import { View } from 'components/View'

export default function CircularProgress ({
  progress,
  width,
  disabled,
  isSelected
}) {
  const dashOffset = 100 - progress
  const rotationAngle = 360 * (progress / 100) + 90

  if (disabled || progress === 0) {
    return (
      <View w={`${width}px`}>
        <svg
          viewBox='32 30 37 40'
          style={{ transform: 'rotate(-90deg)' }}
        >
          <circle
            r='16'
            cx='50'
            cy='50'
            style={{
              stroke: isSelected ? '#151D21' : '#DDDDDD',
              strokeWidth: 0.5,
              fill: 'none'
            }}
          />
        </svg>
      </View>
    )
  }

  return (
    <View w={`${width}px`}>
      <svg
        viewBox='32 30 37 40'
        style={{ transform: 'rotate(-90deg)' }}
      >
        <circle
          r='16'
          cx='50'
          cy='50'
          style={{
            stroke: '#f6f6f6',
            strokeWidth: 0.5,
            fill: 'none'
          }}
        />
        <circle
          r='16'
          cx='50'
          cy='50'
          strokeDashoffset={dashOffset || 0}
          style={{
            stroke: isSelected ? '#151D21' : '#DDDDDD',
            strokeWidth: 0.5,
            fill: 'none',
            strokeLinecap: 'round',
            strokeDasharray: '100 100',
            transition: 'stroke-dashoffset 1s ease'
          }}
        />
        {(progress && progress !== 100) && (
          <circle
            r='1'
            cx='50'
            cy='34'
            style={{
              transform: `rotate(${rotationAngle}deg)`,
              fill: isSelected ? '#151D21' : '#DDDDDD',
              transformOrigin: '50px 50px',
              transition: 'transform 1s ease'
            }}
          />
        )}
      </svg>
    </View>
  )
}
